import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePostHogPageview } from '../utils/posthog';

/**
 * Reports a pageview whenever the route changes, which `capture_pageview: false`
 * leaves to us. Keyed on pathname only: the query string carries `shop`, `host`
 * and — briefly — a GoStock key, so keying on it too would fire duplicate
 * pageviews every time a param is added or scrubbed.
 */
export function usePostHogPageview() {
  const { pathname } = useLocation();

  useEffect(() => {
    capturePostHogPageview();
  }, [pathname]);
}
